// "After they click Confirm, they…": one choice that covers what happens after
// a double opt-in confirm click. It's stored in two campaign settings —
// incentive_delivery (how a reward reaches them) and confirm_email_url (their
// own page, "" = the built-in "You're confirmed!" page) — whose interplay the
// backend decides: a reward sent straight away or on the confirmed page wins
// over their page; with a follow-up email they go to their page (or the
// confirmed page) and get the reward by email. Pure, so it's unit-tested.

const CONFIRMED = "see “You're confirmed!”";

// The choices, with or without a reward. usesUrl: their page's address field
// shows under it (and is saved); delivery: the incentive_delivery it means.
export function afterConfirmOptions(withReward) {
  if (!withReward) {
    return [
      { value: "confirmed", label: CONFIRMED, usesUrl: false },
      { value: "page", label: "go to your page", usesUrl: true },
    ];
  }
  return [
    { value: "reward", label: "go straight to their reward", usesUrl: false, delivery: "redirect" },
    { value: "reward_page", label: `${CONFIRMED}, then their reward opens`, usesUrl: false, delivery: "page" },
    { value: "page_followup", label: "go to your page, and get their reward in a follow-up email", usesUrl: true, delivery: "email" },
    { value: "confirmed_followup", label: `${CONFIRMED}, and get their reward in a follow-up email`, usesUrl: false, delivery: "email" },
  ];
}

// afterConfirmChoice reads the choice from the settings.
export function afterConfirmChoice(withReward, delivery, url) {
  const hasUrl = !!(url || "").trim();
  if (!withReward) return hasUrl ? "page" : "confirmed";
  if (delivery === "page") return "reward_page";
  if (delivery === "email") return hasUrl ? "page_followup" : "confirmed_followup";
  return "reward";
}

// afterConfirmSettings is what a choice saves: the incentive delivery (kept
// as it was without a reward) and their page's address ("" unless the choice
// uses it).
export function afterConfirmSettings(choice, withReward, delivery, url) {
  const option = afterConfirmOptions(withReward).find((o) => o.value === choice) || afterConfirmOptions(withReward)[0];
  return {
    incentiveDelivery: option.delivery || delivery || "redirect",
    confirmedUrl: option.usesUrl ? (url || "").trim() : "",
    usesUrl: option.usesUrl,
  };
}

// afterConfirmSummary: the flow in one line, e.g.
// "Confirm → https://acme.test/welcome · then the follow-up email with their reward".
export function afterConfirmSummary(choice, url) {
  const page = (url || "").trim() || "your page";
  switch (choice) {
    case "reward": return "Confirm → their reward opens";
    case "reward_page": return "Confirm → “You're confirmed!” → their reward opens";
    case "page_followup": return `Confirm → ${page} · then the follow-up email with their reward`;
    case "confirmed_followup": return "Confirm → “You're confirmed!” · then the follow-up email with their reward";
    case "page": return `Confirm → ${page}`;
    default: return "Confirm → “You're confirmed!”";
  }
}
